import React from "react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Box,
  CircularProgress,
  Typography,
  SnackbarProps,
} from "@mui/material";
import { USERAXIOS } from "../../../../../../api/userAxios";
import { openSnackbar } from "api/snackbar";
import MainCard from "components/MainCard";
import { CompanyDetails } from "../../../../../../types/companies-managment/Company";
import CompanyComments from "../../company-comments/companyComments";
import CompanyPackages from "./CompanyPackages";
import AccountHolder from "./AccountHolder";
import CompanyEmployeeInfo from "./CompanyEmployeeInfo";
import CompanyContactInfo from "./CompanyContactInfo";
import CompanyInformation from "./CompanyInformation";

const ViewCompany = () => {
  const { companyId: id } = useParams();
  const [loading, setLoading] = useState(true);
  const [company, setCompany] = useState<CompanyDetails | null>(null);

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const response = await USERAXIOS.get(`/company_profiles/${id}`);
        setCompany(response.data.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching company details:", error);
        openSnackbar({
          open: true,
          message: "Error fetching company details",
          anchorOrigin: { vertical: "top", horizontal: "right" },
          variant: "alert",
          alert: {
            color: "error",
          },
        } as SnackbarProps);
        setLoading(false);
      }
    };

    fetchCompany();
  }, [id]);

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="400px"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!company) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="400px"
      >
        <Typography variant="h5">Company not found</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "2rem" }}>
      <CompanyPackages companyId={id} />
      <AccountHolder company={company} />
      <CompanyContactInfo company={company} />
      <CompanyInformation company={company} />
      <CompanyEmployeeInfo company={company} />
      <MainCard title="Company Comments">
        {id && <CompanyComments companyId={id} />}
      </MainCard>
    </Box>
  );
};

export default ViewCompany;
